// This is a write only key and hence we can keep it in FE, there is not other option.
// https://github.com/bugsnag/bugsnag-js/issues/595#issuecomment-514578712
export const BUGSNAG_API_KEY = "4537f634332141933aabced249871e5a";
export const BUGSNAG_ENABLED_RELEASE_STAGES = ["production", "staging"];

export const staticAssetUrl = (path: string) =>
  path ? `${window.CDN_HOST}/${path}` : window.CDN_HOST;

const BASE_LOCAL_STORAGE_KEY = window.BASE_LOCAL_STORAGE_KEY;

const appendBaseKeyToLocalStorage = (key: string) =>
  `${BASE_LOCAL_STORAGE_KEY}-${key}`;

// NOTE: we want to limit our local storage useage and remove this code once we upgrade
export const LOCALSTORAGE_KEYS = {
  SpaceGroupsContextProvider: appendBaseKeyToLocalStorage(
    "SpaceGroupsContextProvider",
  ),
  SpacesContextProvider: appendBaseKeyToLocalStorage("SpacesContextProvider"),
  PunditUserContext: appendBaseKeyToLocalStorage("PunditUserContext"),
  QueryClient: appendBaseKeyToLocalStorage("QueryClient"),
} as const;

export const getIconUrl = (iconFile: string) =>
  staticAssetUrl(`app-assets/icons/${iconFile}`);
